import React, { useContext, useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@material-ui/core';

import { UserContext } from 'contexts/UserContext';
import { TabPanel } from 'shared';

import { ReceivablePurchaseOrders } from './receivablePurchaseOrders';

function Receiving({ baseUrl }) {
    const user = useContext(UserContext);
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="Receive Purchase Order" value="0" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ReceivablePurchaseOrders />
            </TabPanel>
        </Paper>
    );
}

export { Receiving };
